export enum FreemiumMessages {
  BEST_PRACTICE_RECOMMENDATION_TITLE = "Best Practice Recommendation",
  BEST_PRACTICE_RECOMMENDATION_MESSAGE = "For the best experience, we recommend using the web version of this page. The mobile version may not be fully adapted for all features."
}
